const KEY = "aic_cookie_consent";
export const CONSENT_EVENT = "cookie-consent-changed";

export const getConsent = () => localStorage.getItem(KEY);
export const setConsent = (v) => {
  if (v) { localStorage.setItem(KEY, v); } else { localStorage.removeItem(KEY); }
  window.dispatchEvent(new Event(CONSENT_EVENT));
};
